app.controller('BrowseCommonStandardSizeController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {


    $scope.product = $scope.partial_product;
    const product = $scope.product;

    $scope.m2m_will_be_available = $scope.navigation_values.site_range_m2m_expected;

    $scope.applyProduct = function (partialProduct) {
        $scope.product = partialProduct;
    }

    $scope.openStandardSizeSelect = function () {

        function applyCurrentMatrix() {
            let i, j;

            const filtered = [];
            if (product.price_matrix.length > 0) {
                for (i = 0; i < product.price_matrix.length; i++) {
                    if (!product.price_matrix[i][0].heightHidden) {
                        const row = [];
                        for (j = 0; j < product.price_matrix[i].length; j++) {
                            if (!product.price_matrix[i][j].widthHidden) {
                                row.push(product.price_matrix[i][j]);
                            }
                        }
                        filtered.push(row)
                    }

                }
            }

            for (i = 0; i < filtered.length; i++) {
                for (j = 0; j < filtered[i].length; j++) {
                    const productData = filtered[i][j].product_data;
                    if (productData) {
                        for (let doorOptionID in productData) {
                            const doorOptionData = productData[doorOptionID];
                            if (doorOptionData) {
                                const price = doorOptionData.getMatrixPrice();
                                doorOptionData.formatted_price = $rootScope.service.currency.currencyFormatDisplayPrice(price, true)
                            }
                        }
                    }
                }
            }
            return filtered;
        }

        const filteredPriceMatrix = applyCurrentMatrix();

        $bootstrapModal.open({
            templateUrl: 'BrowseCommonModalStandardSize.html',
            controller: 'CommonModalSimpleController',
            //size: 'lg',
            resolve: {
                items: {
                    product: product,
                    filtered_price_matrix: filteredPriceMatrix,
                    selectWidthHeight: function (width, height, doorOptionID, callback) {

                        product.height = height;
                        product.width = width;

                        product.expected_door_option_id = doorOptionID;
                        product.find_available_door_options = true;

                        if (!product.find_option_term_choice) {
                            product.find_option_term_choice = {};
                        }
                        product.find_option_term_choice.selected_door_option = doorOptionID;
                        if (callback) {
                            callback();
                        }

                    },
                    doorOptionName: function (doorOption, isDrawer) {
                        if (doorOption.id === "door") {
                            if (isDrawer) {
                                return "drawer";
                            }
                        }
                        return doorOption.name;
                    },
                    isDrawer: function (standardHeight) {
                        return standardHeight < 283;
                    }
                }
            }
        });
    };


}]);